<template>
    <div class="pa-3 grey lighten-4">
        <v-card-title class="grey lighten-4 pa-0">
            <v-spacer></v-spacer>
            <v-btn small color="success" @click="savePage()">Save</v-btn>
        </v-card-title>
        <v-card-text class="px-0">
            <v-layout row wrap>
                <v-flex xs6>
                    <v-card class="mx-3" >
                        <v-card-title class="grey lighten-4 pa-2 ">
                            <h5>{{ $t("admin.page.appearance.customize.widgets.available.widgets") }}</h5>
                        </v-card-title>

                        <v-card-title v-if="availableWidgets.length" primary-title>
                            <div v-if="!remainingWidgets.length" class="text-xs-center greyDarken3--text">
                                {{ $t('admin.page.appearance.customize.widgets.no.available.widgets.message') }}
                            </div>
                            <draggable class="draggableItem" :list="remainingWidgets" group="people" @change="log">
                                <v-card
                                    v-for="widget in remainingWidgets"
                                    :key="widget.id"
                                    :class="`ma-1 my-3 pa-2`"  width="100%"
                                    hover
                                >
                                    <h4 class="greyDarken3--text">{{ widget.name[$i18n.locale] }}</h4>
                                </v-card>
                            </draggable>
                        </v-card-title>
                    </v-card>
                </v-flex>
                <v-flex xs6>
                    <v-card class="mx-3" >
                        <v-card-title class="grey lighten-4 pa-2">
                            <h5>{{ $t("admin.page.appearance.customize.widgets.applied.widgets") }}</h5>
                        </v-card-title>
                        <v-card-title v-if="availableWidgets.length" primary-title>
                            <v-card class="ma-1 my-3 pa-2 item exclude-this-item grey lighten-2"  
                                width="100%" hover v-if="headerWidget">
                                <h4 :class="`greyDarken3--text `">{{ headerWidget.name[$i18n.locale] }}</h4>
                            </v-card>
                            <v-divider></v-divider>
                            <draggable
                                class="draggableItem"
                                :list="appliedWidgets"
                                group="people"
                                @change="log"
                            >
                                <v-card v-for="widget in appliedWidgets" :key="widget.id" :class="`ma-1 my-3 pa-2 item ${!isDraggable(widget.type) ?'exclude-this-item grey lighten-2' :'' }`"  width="100%" hover>
                                    <h4 :class="`greyDarken3--text `">{{ widget.name[$i18n.locale] }}</h4>
                                </v-card>
                            </draggable>
                            <v-divider></v-divider>
                            <v-card class="ma-1 my-3 pa-2 item exclude-this-item grey lighten-2"  
                                width="100%" hover v-if="footerWidget">
                                <h4 :class="`greyDarken3--text `">{{ footerWidget.name[$i18n.locale] }}</h4>
                            </v-card>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-text class="subtitle py-0 font-italic greyDarken3--text">{{ $t('admin.page.appearance.customize.widgets.drag.note') }}</v-card-text>
    </div>
</template>
<script>
import draggable from "vuedraggable";
import DEFINES from "@/defines";
export default {
    name: "ManagePageWidgets",
    components: {
        draggable
    },
    props: {
        page: {
            type: Object,
            required: true,
            default: null
        },
        availableWidgets: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data: function() {
        return {
            headerWidget:{},
            footerWidget:{},
            appliedWidgets: [],
            remainingWidgets: []
        }
    },
    computed: {
        widgetIds() {
            let updatedWidgetIDS = new Set([this.headerWidget.id,...this.appliedWidgets.map(obj => obj.id),this.footerWidget.id])
            // this.page.widget_ids = [...updatedWidgetIDS]
            return updatedWidgetIDS
        }
    },
    created() {
        this.cloneWidgets();
    },
    methods: {
        async cloneWidgets() {
            
            // Step 1: From applied Widgest Filter header and footer
            this.headerWidget = this.availableWidgets.find((element) => element.slug === 'header');
            this.footerWidget = this.availableWidgets.find((element) => element.slug === 'footer');

            // Step 2: Remove Header and Fotter from the List so that we left with only dynamic widgets
            // this.appliedWidgets = this.page.widgets.filter((element) => !['header','footer'].includes(element.slug))
            this.appliedWidgets = this.page.widget_ids
            .map(id => this.page.widgets.find(widget => widget.id === id))
            .filter(widget => widget && !['header', 'footer'].includes(widget.slug));

            let appliedWidgetsIds = new Set([this.headerWidget.id, ...this.appliedWidgets.map(obj => obj.id),this.footerWidget.id])
            
            this.remainingWidgets = this.availableWidgets.filter(obj => !appliedWidgetsIds.has(obj.id))

        },
        log: function(evt) {
            window.console.log(evt);
        },
        isDraggable(widgetType) {
            
            if(widgetType == DEFINES.WIDGETS.TYPE_HEADER){
                return false
            }

            if(widgetType == DEFINES.WIDGETS.TYPE_FOOTER){
                return false
            }
            return true
        },
        async savePage() {
            try {
                this.page.widget_ids = [...this.widgetIds]
                var response = await this.$store.dispatch("adminPage/update", this.page);
                this.$store.dispatch("app/showMessage", {
                    message: "Updated Successfully",
                    color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
                });
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error"
                });
            }
        },
    }
}
</script>
<style scoped>
    .draggableItem {
        width: 100%;
        height: 100%;
    }
</style>
